export default class CustomerView {

    constructor(customerView) {
        this.nodes = customerView !== undefined ? customerView.nodes : []
        this.relationships = customerView !== undefined ? customerView.relationships : []
    }

    getNodes() {
        return this.nodes.map((node) => {
            return node.label;
        });
    }

    getAttributes(selectedNode) {
        let node = this.nodes.find(n => n.label === selectedNode);
        return node.attributes.map((attribute) => {
            return attribute.label;
        })
    }

    getRelationships(node) {
        let relationships = [];
        this.relationships.forEach(relationship => {
            let inNodes = relationship.in_nodes.map((r) => {
                return r.label;
            });
            let outNodes = relationship.out_nodes.map((r) => {
                return r.label;
            });

            if (inNodes.includes(node) && outNodes.includes(node)) {
                relationships.push({ label: relationship.label, direction: 'up'})
                relationships.push({ label: relationship.label, direction: 'down'})
            } else if (inNodes.includes(node)) {
                relationships.push({ label: relationship.label, direction: 'down'})
            } else if (outNodes.includes(node)) {
                relationships.push({ label: relationship.label, direction: 'up'})
            }
        });

        return relationships;
    }

    getNodesForRelationship(label, direction) {
        let relationship = this.relationships.find(r => r.label === label);
        if (direction === "up") {
            let outNodes = relationship.in_nodes.map((r) => {
                return r.label;
            });
            return outNodes;
        } else {
            let inNodes = relationship.out_nodes.map((r) => {
                return r.label;
            });
            return inNodes;
        }

    }
}


// WEBPACK FOOTER //
// ./src/customerView/CustomerView.js